// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"f26804d3","977":"d440b084"}[chunkId] + ".chunk.js";
};